import { useState, useContext } from 'react'
import { Route, Switch, Redirect, useLocation } from 'react-router-dom'
import SideMenu from './components/SideMenu'
import Login from './components/Login'
import Dashboard from './components/Dashboard'
import News from './components/News'
import Notice from './components/Notice'
import Gallary from './components/Gallary'
import ExamPaper from './components/ExamPaper'
import { UserContext } from './context/UserContext'
import './App.css'

const App = () => {
  const [inactive, setInactive] = useState(false)
  const { loggedIn } = useContext(UserContext)
  let location = useLocation();

  return (
    <div className="App">
        {
          loggedIn ?
            <>
              <SideMenu
                onCollapse={(inactive) => {
                  setInactive(inactive)
                }}
              />
              <div className={`container ${inactive ? 'inactive' : ''}`}>
                <Switch location={location}>                 
                  <Route exact path="/" component={Dashboard} />                  
                  <Route exact path="/content/college-news" component={News} />                  
                  <Route exact path="/content/notice" component={Notice} />                  
                  <Route exact path="/gallary" component={Gallary} />
                  <Route exact path="/exam-paper" component={ExamPaper} />
                  <Redirect to="/" />
                </Switch>
              </div>
            </>
            : <>
                <Route exact path="/" component={Login} />
                <Route exact path="/login" component={Login} />
                <Redirect to={"/"} />
              </>
        }
    </div>
  );
}

export default App;
